import { render, staticRenderFns } from "./meta-internal-notes-field.vue?vue&type=template&id=29ec2fea&scoped=true&"
import script from "./meta-internal-notes-field.vue?vue&type=script&lang=js&"
export * from "./meta-internal-notes-field.vue?vue&type=script&lang=js&"
import style0 from "./meta-internal-notes-field.vue?vue&type=style&index=0&id=29ec2fea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ec2fea",
  null
  
)

export default component.exports